import { getShellApiInstance } from './shell-api-instance'

const getContext = () => getShellApiInstance()?.context

export const getPbxFromContext = () => getContext()?.pbx
export const getAccountFromContext = () => getContext()?.account
